import { render, staticRenderFns } from "./showContent.vue?vue&type=template&id=509acc0d&scoped=true"
import script from "./showContent.vue?vue&type=script&lang=js"
export * from "./showContent.vue?vue&type=script&lang=js"
import style0 from "./showContent.vue?vue&type=style&index=0&id=509acc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509acc0d",
  null
  
)

export default component.exports